// extracted by mini-css-extract-plugin
export default {"grid":"IntegrationsContent-module--grid--82919"};